import React, { useState, useEffect } from 'react';
import axios from 'axios';

import LessonPlanLibraryIcon from '../img/plan.gif';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import { PencilSquare, Trash, Search, InfoCircleFill, CheckCircleFill } from 'react-bootstrap-icons';

function LessonPlanLibrary() {
  const [searchTerm, setSearchTerm] = useState('');
  const [lessonPlans, setLessonPlans] = useState([]);
  const [filteredLessonPlans, setFilteredLessonPlans] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentLessonPlan, setCurrentLessonPlan] = useState({
    id: null,
    title: '',
    description: '',
    course: '',
    batch: '',
    date: ''
  });

  const [showModal, setShowModal] = useState(false); // State for showing the modal
  const [successMessage, setSuccessMessage] = useState(''); // State for success message

  useEffect(() => {
    // Fetch lesson plans from the backend
    const fetchLessonPlans = async () => {
      try {
        const response = await axios.get('http://localhost:5000/lesson-plans/lesson-plans');
        setLessonPlans(response.data);
        setFilteredLessonPlans(response.data);
      } catch (error) {
        console.error('Error fetching lesson plans:', error);
      }
    };

    fetchLessonPlans();
  }, []);

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
    filterLessonPlans(event.target.value);
  };

  // Function to filter lesson plans based on search term
  const filterLessonPlans = (term) => {
    const filtered = lessonPlans.filter((plan) =>
      plan.title.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredLessonPlans(filtered);
  };

  // Function to handle input change for lesson plan form
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentLessonPlan({ ...currentLessonPlan, [name]: value });
  };

  // Function to handle form submission for creating/editing lesson plan
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    if (isEditing) {
      // Update lesson plan
      try {
        await axios.put(`http://localhost:5000/lesson-plans/lesson-plans/${currentLessonPlan.id}`, currentLessonPlan);
        const updatedLessonPlans = lessonPlans.map(plan =>
          plan.id === currentLessonPlan.id ? currentLessonPlan : plan
        );
        setLessonPlans(updatedLessonPlans);
        setFilteredLessonPlans(updatedLessonPlans);
        setIsEditing(false);
        setShowModal(false); // Close modal after submit
        setSuccessMessage('Lesson Plan Updated');
        setTimeout(() => {
          setSuccessMessage('');
        }, 3000); // Clear success message after 3 seconds
      } catch (error) {
        console.error('Error updating lesson plan:', error);
      }
    } else {
      // Create new lesson plan
      try {
        const response = await axios.post('http://localhost:5000/lesson-plans/lesson-plans', currentLessonPlan);
        const newLessonPlan = { ...currentLessonPlan, id: response.data.id };
        setLessonPlans([...lessonPlans, newLessonPlan]);
        setFilteredLessonPlans([...filteredLessonPlans, newLessonPlan]);
        setShowModal(false); // Close modal after submit
        setSuccessMessage('Lesson Plan Created');
        setTimeout(() => {
          setSuccessMessage('');
        }, 3000); // Clear success message after 3 seconds
      } catch (error) {
        console.error('Error creating lesson plan:', error);
      }
    }
    setCurrentLessonPlan({ id: null, title: '', description: '', course: '', batch: '', date: '' });
  };

  // Function to handle editing a lesson plan
  const handleEditLessonPlan = (lessonPlan) => {
    setIsEditing(true);
    setCurrentLessonPlan(lessonPlan);
    setShowModal(true); // Open modal for editing
  };

  // Function to handle deleting a lesson plan
  const handleDeleteLessonPlan = async (id) => {
    try {
      await axios.delete(`http://localhost:5000/lesson-plans/lesson-plans/${id}`);
      const updatedLessonPlans = lessonPlans.filter(plan => plan.id !== id);
      setLessonPlans(updatedLessonPlans);
      setFilteredLessonPlans(updatedLessonPlans);
      setShowModal(false); // Close modal after delete
      setSuccessMessage('Lesson Plan Deleted');
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000); // Clear success message after 3 seconds
    } catch (error) {
      console.error('Error deleting lesson plan:', error);
    }
  };

  // Function to toggle modal
  const toggleModal = () => {
    setShowModal(!showModal);
    setCurrentLessonPlan({ id: null, title: '', description: '', course: '', batch: '', date: '' });
    setIsEditing(false);
  };
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  

  return (
    <>
      <div className='container-fluid ' style={{fontFamily:'Poppins, san-serif'}}>
        <div className='row'>
          <div className='dashboard d-flex flex-wrap'>
         
            <div className="dashboard-Container col">
              <div className="lesson-plan-library-page container-fluid">
                <div className='row my-4'>
                  <div className='col-12'>
                    <h3>Lesson Plan Library<img className='animated-icons' src={LessonPlanLibraryIcon} alt='Lesson Plan icon'/></h3>
                  </div>
                  <div className='input-group mb-3'>
                    {/* Search input */}
                    <input
                      type="text"
                      className="form-control border-0"
                      placeholder="Search lesson plans..."
                      value={searchTerm}
                      onChange={handleSearchInputChange}
                    />
                    <div className="input-group-append">
                   
                   <Search className='mx-3 my-2' />
                 
                 
               </div>
                  </div>
                </div>

                {/* Button to open modal */}
                <div className='row mb-4'>
                  <div className='col-12'>
                    <button className='btn btn-success' onClick={toggleModal}>
                      {isEditing ? 'Edit Lesson Plan' : 'Create New Lesson Plan'}
                    </button>
                  </div>
                </div>

                {/* Success message */}
                {successMessage && (
                  <div className="alert alert-success" role="alert" style={{zIndex:'100', position:'fixed',
                    top:'0',right:'0'
                  }}><CheckCircleFill className='text-success mx-1'/>
                    {successMessage}
                  </div>
                )}

                {/* Display filtered lesson plans */}
                <div className="row">
                  {filteredLessonPlans.map((lessonPlan) => (
                    <div className="col-lg-4 col-md-6" key={lessonPlan.id}>
                      <div className="card mb-4">
                        <div className="card-body">
                          <h5 className="card-title">{lessonPlan.title}</h5>
                          <p className="card-text">{lessonPlan.description}</p>
                          <p className="card-text">Course: {lessonPlan.course}</p>
                          <p className="card-text">Batch or Class: {lessonPlan.batch}</p>
                          <p className="card-text">Date: {formatDate(lessonPlan.date)}</p>
                          <button onClick={() => handleEditLessonPlan(lessonPlan)} className='btn btn-primary btn-sm   col-6'>
                          <PencilSquare />
                          </button>
                          <button onClick={() => handleDeleteLessonPlan(lessonPlan.id)} className='btn btn-danger btn-sm col-6'>
                          <Trash/>
                            </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Modal */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? 'Edit Lesson Plan' : 'Create New Lesson Plan'}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form onSubmit={handleFormSubmit}>
                      <div className='form-group'>
                        <label>Title</label>
                        <input
                          type='text'
                          className='form-control'
                          name='title'
                          value={currentLessonPlan.title}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className='form-group'>
                        <label>Description</label>
                        <textarea
                          className='form-control'
                          name='description'
                          value={currentLessonPlan.description}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className='form-group'>
                        <label>Course</label>
                        <input
                          type='text'
                          className='form-control'
                          name='course'
                          value={currentLessonPlan.course}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className='form-group'>
                        <label>Batch or Class</label>
                        <input
                          type='text'
                          className='form-control'
                          name='batch'
                          value={currentLessonPlan.batch}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className='form-group'>
                        <label>Date</label>
                        <input
                          type='date'
                          className='form-control'
                          name='date'
                          value={currentLessonPlan.date}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                      </Button>
                      <Button variant="primary" type="submit">
                        {isEditing ? 'Update Lesson Plan' : 'Create Lesson Plan'}
                      </Button>
                    </form>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LessonPlanLibrary;
